import React, { Component } from 'react';

class Work extends Component {
    render() {
        return (
            <div>
                This is work
            </div>
        );
    }
}

export default Work;